<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group
          @reset="$gjReset"
          @query="$gjNoticeQuery"
      >
        <!-- 全部国家-->
        <gj-country-server-select
            v-model="filter.countryMarketValue"
        >
        </gj-country-server-select>
        <!--  全部状态-->
        <gj-select
            v-model="filter.status"
            :options="option.followDisableOption"
            placeholder="全部状态"
            width="140px"
        >
        </gj-select>
        <gj-creator-select
            v-model="filter.createUserId"
            placeholder="监控人"
        ></gj-creator-select>
        <gj-search-input
            v-model="filter.asin"
            placeholder="请输入ASIN"
            width="200px"
            @input="changeAsin"
        ></gj-search-input>

        <template #right>
          <view-setting
                  :ref="REF_VIEW_SETTING"
                  save-mode="remote"
                  :use-default="true"
                  :module-name="moduleName"
                  :config="model"
                  @view-change="handleChangeView"
                  @view-complete="handCompleteView"
          >
          </view-setting>
        </template>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button v-if="$permission('offerMonitor:add')" :disabled="orderNumber <= 0 || virtualNumber <= 0" type="primary" @click="add">添加监控ASIN</gj-button>
      <gj-button v-if="$permission('offerMonitor:edit')"
          :disabled="noSelect"
          @click="activeTag(selectedRows)"
      >启用</gj-button>
      <gj-button v-if="$permission('offerMonitor:edit')"
          :disabled="noSelect"
          @click="inactiveTag(selectedRows)"

      >停用</gj-button>
      <gj-button v-if="$permission('offerMonitor:delete')"
          :disabled="noSelect"
          @click="deleteTag(selectedRows)"
      >删除</gj-button>
      <!-- <span style="font-size: 12px;color: #999;display: inline-block;" v-if="tenantPay&&tenantPay.payStatus&&tenantPay.payStatus.code==='NOT_PAID'&&userInfo&&userInfo.freeOrder === true">(可免费添加20个)</span> -->
    </template>
    <template #tool-group>
      <gj-tool-group help></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :columns="columns"
          :name="tableName"
          :data="data"
          :pagination="pagination"
          :loading="loading"
          selection
          :size="'has-picture'"
          :show-overflow="false"
          :default-sort="{prop: 'updateTime', order: 'descending'}"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
          :expand = "data.length > 0"
      >
        <template v-slot:picture="{row}">
          <gj-image
              :src="row.imageUrl"
              :tag="row.testOrder ? '推' : null"
              tag-color="rgb(246 144 10)">
          </gj-image>
        </template>
        <template v-slot:asin="{row}">
          <a :href="row.asinUrl" class="asinUrl" target="_blank">
            {{row.asin}}
          </a>
        </template>
        <template v-slot:listingTitle="{row}">
          <div class="text-ellipsis-2">
            <gj-tooltip :text-line="1" :content="row.listingTitle">
              {{row.listingTitle}}
            </gj-tooltip>
          </div>
        </template>
        <template v-slot:offerNum="{row}">
          {{row.offerNum}}
        </template>
        <template v-slot:exceptSellerIds="{row}">
          <gj-tooltip :text-line="1" :content="row.exceptSellerIds ? row.exceptSellerIds.join(',') : '-'">
            {{row.exceptSellerIds ? row.exceptSellerIds.join(",") : "-"}}
          </gj-tooltip>
        </template>
        <template v-slot:status="{row}">

          <gj-tag
              type="text"
              :color="row.status === 'Active'?tagColors.greenText:tagColors.gray9Text">
            {{row.status === "Active" ? "启用" : "停用" }}
          </gj-tag>

        </template>
        <template v-slot:updateTime="{row}">
          {{row.updateTime || "-"}}
        </template>
        <template v-slot:offerUserNames="{row}">
          {{row.offerUserNames.join(",")}}
        </template>
        <template v-slot:createUserName="{row}">
          {{row.createUserName || "-"}}
        </template>
        <template v-slot:createTime="{row}">
          {{row.createTime || "-"}}
        </template>
        <!-- 操作项-->
        <template v-slot:op="{row}">
          <gj-button-group type="dropdown-op">
            <gj-button v-if="$permission('offerMonitor:view')" type="text" @click="opDetailModal(row)">跟卖详情</gj-button>
            <gj-button v-if="$permission('offerMonitor:edit') && row.status === 'Active'" type="text" @click="deactivate(row)">停用</gj-button>
            <gj-button v-if="$permission('offerMonitor:edit') && row.status === 'Inactive'" type="text" @click="deactivate(row)">启用</gj-button>
            <template #dropdown>
              <gj-dropdown-item v-if="$permission('offerMonitor:edit')" @click="editFollowItem(row)">
                编辑
              </gj-dropdown-item>
              <gj-dropdown-item v-if="$permission('offerMonitor:delete')" @click="delFollowItem(row.id)">删除
              </gj-dropdown-item>
            </template>
          </gj-button-group>
        </template>
        <template v-slot:expand ="{row}">
          {{row.createTime}}
        </template>
        <template v-slot:expand="{expandRow}" #table v-if="data.length>0">
          <gj-table
              ref="gjTable2"
              :data="expandRow.items || []"
              :columns="expandColumns"
              :adapt-height="false"
              width="100%"
              :index="false">
            <template v-slot:offerSellerId="{row}">
              {{row.offerSellerId}}
            </template>
            <template v-slot:listingPrice="{row}">
              {{ row.listingPriceCurrencySymbol + row.listingPrice }}
            </template>
            <template v-slot:buyBoxWinner="{ row }">
              {{row.buyBoxWinner ? "是" : "否"}}
            </template>
            <template v-slot:fulfillmentChannel="{ row }">
              {{row.fulfillmentChannel}}
            </template>
            <template v-slot:fulfilledByAmazon="{ row }">
              {{row.fulfilledByAmazon ? "亚马逊自营" : "普通卖家"}}
            </template>
            <template v-slot:followerInfo="{ row }">
              {{row.positiveFeedbackRating + "% positive over the past 12 months.(" + row.feedbackCount +"total ratings)"}}
            </template>
            <template v-slot:offerStartTime="{ row }">
              {{row.offerStartTime}}
            </template>
            <template v-slot:offerEndTime="{ row }">
              {{row.offerEndTime}}
            </template>
          </gj-table>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import {saleOrderStatus, followDisableOption} from "@/utils/options";
import {transformToMap, isMeaningful} from "@/utils/common";
//跟卖详情modal
import FollowUpDetail from './modal/follow-up-detail';
import EditFollowUpItem from "./modal/edit-follow-up-item"
import {subDays} from "date-fns";
import {queryMixin, responseMixin, selectionMixin} from "@/minxins";
import { getFollowList,updateFollowStatus,delFollow } from "@/api/tool"
import {mapGetters} from "vuex";
import AppAddMonitoringASIN from "./add/add-monitoring-ASIN";
import viewConfig from './viewConfig'
import {tagColors} from "@/components/tag/tag-colors";
import {getTenantOrderDetailed} from "@/api/user";
export default {
  name: "app-follow-up",
  mixins: [selectionMixin, queryMixin, responseMixin],
  computed: {
    ...mapGetters(['marketOption', 'tenantPay', 'userInfo']),
  },
  created() {
    this.sort.prop = 'updateTime';
     this.getOderNumber();
  },
  activated() {
    this.getOderNumber();
  },
  data() {
    return {
      tagColors,
      tableName: 'follow',
      columns: [
        {
          id: 'marketId',
          header: '店铺/国家',
          field: 'option:marketId',
          minWidth: '100px',
          // fixed: 'left',
          default: true,
          disabled: true,
          options: () => this.marketOption
        },
        {
          id: 'picture',
          header: '图片',
          field: 'slot:picture',
          minWidth: '60px',
          // fixed: 'left',
          default: true,
          disabled: true,
        },
        {
          id: 'asin',
          header: 'ASIN',
          field: 'slot:asin',
          minWidth: '100px',
          // fixed: 'left',
          default: true,
          disabled: true,
        },
        {
          id: 'listingTitle',
          header: '标题',
          field: 'slot:listingTitle',
          minWidth: '160px',
          default: true,
          disabled: true,
        },
        {
          id: 'offerNum',
          header: '跟卖数量',
          field: 'slot:offerNum',
          minWidth: '70px',
          default: true,
          disabled: true,
        },
        {
          id: 'exceptSellerIds',
          header: '排除店铺',
          field: 'slot:exceptSellerIds',
          minWidth: '160px',
          default: true,
          disabled: true,
        },
        {
          id: 'status',
          header: '状态',
          field: 'slot:status',
          minWidth: '60px',
          default: true,
          disabled: true,
        },
        {
          id: 'updateTime',
          header: '更新时间',
          field: 'slot:updateTime',
          minWidth: '155px',
          default: true,
          disabled: true,
        },
        {
          id: 'offerUserNames',
          header: '监控人',
          field: 'slot:offerUserNames',
          minWidth: '100px',
          default: true,
          disabled: true,
        },
        {
          id: 'createUserName',
          header: '创建人',
          field: 'slot:createUserName',
          minWidth: '110px',
          default: true,
          disabled: true,
        },
        {
          id: 'createTime',
          header: '创建时间',
          field: 'slot:createTime',
          minWidth: '155px',
          default: true,
          disabled: true,
        },
        {id: 'op', header: '操作', field: 'slot:op', minWidth: '150px', default: true, notCustomColumn: true},
      ],
      expandColumns: [
        {id: 'offerSellerId', header: 'Seller ID', field: 'slot:offerSellerId', maxWidth: '100px', default: true},
        {id: 'listingPrice', header: '跟卖价格', field: 'slot:listingPrice', maxWidth: '100px', default: true},
        {id: 'buyBoxWinner', header: '是否占领黄金购物区', field: 'slot:buyBoxWinner',  maxWidth: '100px', default: true},
        {id: 'fulfillmentChannel', header: '跟卖类型', field: 'slot:fulfillmentChannel', maxWidth: '100px', default: true},
        // {id: 'fulfilledByAmazon', header: '配送渠道', field: 'slot:fulfilledByAmazon',  maxWidth: '100px', default: true},
        {id: 'followerInfo', header: '跟卖者信息', field: 'slot:followerInfo', minWidth: '100px', maxWidth: '100px', default: true},
        {id: 'offerStartTime', header: '跟卖开始时间', field: 'slot:offerStartTime', minWidth: '50px', maxWidth: '100px', default: true},
        // {id: 'offerEndTime', header: '跟卖结束时间', field: 'slot:offerEndTime', minWidth: '50px', maxWidth: '100px', default: true},
      ],
      data: [],
      filter: {
        countryMarketValue: null,
        status: null,
        createUserId: null,
        offerUserIds: [],
        keyword2: {
          key: 'asin',
          value: null,
        },
        marketIds: [],
        asin: "",
        purchaseDate: [subDays(new Date(), 7), new Date()],
      },
      option: {
        followDisableOption: followDisableOption
      },
      statusMap: transformToMap(saleOrderStatus),
      moduleName: 'FOLLOW_UP_MONITORING',
      model: viewConfig,
      cacheOptions: {
        useCache: true,
      },
      orderNumber: 0,   //订单剩余量
      virtualNumber: 0,  //积点剩余量
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(router) {
        if (router && router.query.link === 'promotionAnalysis') {
          this.isInitParams = false;
          this.filter.allOrderType = 5;
          this.filter.keyword2.key = 'asin';
          this.filter.keyword2.value = router.query.asin;
          this.filter.purchaseDate = [router.query.purchaseDate[0], router.query.purchaseDate[1]];
          this.filter.status = null;
        }
      },
    }
  },
  methods: {
    /**
     * 设置全局查询参数
     */
    mergeRemoteParams (params) {
      const purchaseDate = params.purchaseDate ? params.purchaseDate : (params.startDateTime && params.endDateTime ? [params.startDateTime, params.endDateTime] : this.filter.purchaseDate)
      this.filter = Object.assign({}, this.filter, {
        ...params,
        purchaseDate
      })
    },
    $gjQueryInitParams() {
      return {
        filter: {
          countryMarketValue: null,
          status: "",
          asin: '',
          createUserId: null,
        }
      }
    },
    /**
     *
     * @param params 查询条件参数
     * @override queryMixin
     * @returns {{countryMarketValue: *}}
     */
    $gjCacheCallback(params) {
      return {
        countryMarketValue: params.countryMarketValue
      };
    },
    $gjQuery() {
      const _this = this;
      this.loading = true;
      const params = {
        model: {
          ...this.filter,
          offerUserIds: [],
        },
        ...this.queryPagination,
        ...this.querySort
      };
      // params.model[this.filter.keyword2.key] = this.filter.keyword2.value;
      if (this.filter.countryMarketValue) {
        params.model.asin = this.filter.asin;
        params.model.countryCodes = this.filter.countryMarketValue.countryIds;
        params.model.marketIds = this.filter.countryMarketValue.marketIds;
      }
      if(this.filter.createUserId){
        let offerUserIds = [this.filter.createUserId];
        params.model.offerUserIds = offerUserIds;
      }
      this.globalParams = params;
      getFollowList(params)
          .then((result) => {
            _this.data = result.records;
            _this.pagination = _this.getPagination(result);
          })
          .complete(() => {
            _this.loading = false;
          })

    },
    changeAsin(row){
      this.asin = row.asin;
    },

    opDetailModal(row) {
      this.$gjCreate(FollowUpDetail, {
        props: {
          fid: row.id,
          marketId: row.marketId,
          orderId: row.orderId,
          showBtn: true,
          rowItem: row
        }
      })
    },
    //编辑该条跟卖数据
    editFollowItem(row){
      this.$gjCreate(EditFollowUpItem,{
        props:{
          id: row.id,
          row: row
        },
        on: {
          edited: () => {
            this.$gjMessage.success('编辑成功');
            this.$gjResetPage();
            this.getOderNumber();
          },
        },
      })
    },
    //删除该条跟卖数据
    delFollowItem(id) {
      const vm = this;
      let ids = [id];
      let params = { ids };
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          type: 'warning',
          content: `删除数据后不可恢复，确定要删除吗？`,
          title: '删除确认'
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm() {
            // modal.confirmLoading = true;
            delFollow(params).then((res) =>{
              modal.$gjDestroy();
              vm.$gjResetPage();
              vm.getOderNumber();
            })

          }
        },
      });
    },
    //添加监控ASIN
    add() {
      if (this.virtualNumber > 0 && this.virtualNumber < 10) {
        this.$gjMessage.warning('积点数不足10，请去产品套餐页面购买！');
        return;
      }
      this.$gjCreate(AppAddMonitoringASIN, {
        props: {
          marketId: this.marketId,
          portfolioId: this.portfolioId
        },
        on: {
          created: () => {
            this.$gjMessage.success('添加成功');
            this.$gjResetPage();
            this.getOderNumber();
          }
        }
      });
    },
    // 删除数据
    deleteTag(rows) {
      const _this = this;
      let ids = [];
      rows.map(b=>{
        ids.push(b.id);
      })
      let params = { ids, status: "Active"};
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          title: '删除确认',
          // content: rows.length === 1 ? `确定要删除${rows[0].name}吗？` : `已选择标签${rows.length}个，确定要批量删除吗？`,
          content: '删除后数据不可恢复，确认要删除吗？',
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm() {
            delFollow(params).then((res) =>{
              modal.$gjDestroy();
              _this.$gjResetPage();
              _this.getOderNumber();
            })
          }
        },
      });
    },
    //批量停用
    inactiveTag(rows) {
      const _this = this;
      let ids = [];
      rows.map(b=>{
        ids.push(b.id);
      })
      let params = { ids, status: "Inactive"};
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          title: '停用确认',
          type: 'warning',
          // content: rows.length === 1 ? `确定要停用${rows[0].name}吗？` : `已选择标签${rows.length}个，确定要批量停用吗？`,
          content: "停用后系统将不再对此ASIN进行跟卖监控，并释放跟卖监控额度；确认停用吗？",
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm() {
            updateFollowStatus(params).then((res) =>{
              modal.$gjDestroy();
              _this.$gjResetPage();
              _this.getOderNumber();
            })
          }
        },
      });
    },
    //单行启用/停用
    deactivate(row){
      const _this = this;
      let ids = [row.id];
      let status = row.status === "Active" ? "Inactive" : "Active";
      let text = row.status === "Active" ? "停用" : "启用";
      let params = { ids, status };
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          type: 'warning',
          content: text === "启用" ? text + "后系统将对此ASIN进行跟卖监控，并消耗跟卖监控额度，确认启用吗？" : text + "后系统将不再对此ASIN进行跟卖监控，并释放跟卖监控额度；确认停用吗？",
          title: row.status === "Active" ? "停用确认" : "启用确认"
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm() {
            updateFollowStatus(params).then((res) =>{
              modal.$gjDestroy();
              _this.$gjResetPage();
              _this.getOderNumber();
            })
          }
        },
      });

    },
    //批量启用
    activeTag(rows) {
      const _this = this;
      let ids = [];
      rows.map(b=>{
        ids.push(b.id);
      })
      let params = { ids, status: "Active"};
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          title: '启用确认',
          type: 'warning',
          content: "启用后系统将对此ASIN进行跟卖监控，并消耗跟卖监控额度，确认启用吗？",
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm() {
            updateFollowStatus(params).then((res) =>{
              modal.$gjDestroy();
              _this.$gjResetPage();
              _this.getOderNumber();
            })
          }
        },
      });
    },
    // 展开row
    expandLazyLoad(row, index, resolve){
      return resolve(row.items || []);
    },
     //获取订单剩余量
    getOderNumber() {
        getTenantOrderDetailed().then(res => {
        if(isMeaningful(res)) {
          //当订单剩余量===0时，先取免费订单量
          this.orderNumber = res.usableOrder === null || res.usableOrder === 0 ? (res.freeOrder  ? res.freeOrder : 0) : res.usableOrder;
          this.virtualNumber = res.remainingVirtual ? res.remainingVirtual : 0;
        }
      })
    },
  }
}
</script>

<style scoped>
.order-item-mg8 {
  margin-bottom: 8px;
}

.order-item-promotion-mg20 {
  margin-bottom: 20px;
}

.order-tag-mb4 {
  margin-bottom: 4px;
}

/deep/ a.asinUrl {
  color: #1F6EEF;
  text-decoration-line: none;
}
/deep/ .vxe-table .vxe-body--expanded-cell {
  padding: 12px;
}
</style>
